export const agencyProfilePath = (slug: string): string => `/agency/${slug}`;
